<template>
  <div class="swiper-card card-contact">
    <div class="corner-radius-blur"></div>
  
    <transition-group
      name="fade-slide-bottom"
      tag="div"
      class="reveal-group"
      appear
    >
      <div class="icon" :key="'icon'">
        <svg width="169" height="150" viewBox="0 0 169 150" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M114.594 0.0878915C124.072 1.05469 131.467 9.05273 131.467 18.75V131.25C131.467 140.947 124.072 148.945 114.594 149.912L112.686 150H56.3431L54.4357 149.912C44.9571 148.945 37.5621 140.947 37.5621 131.25V18.75C37.5621 9.05273 44.9571 1.05469 54.4357 0.0878915L56.3431 0H112.686L114.594 0.0878915ZM56.3431 14.0625C53.7607 14.0625 51.6479 16.1719 51.6479 18.75V131.25C51.6479 133.828 53.7607 135.938 56.3431 135.938H112.686C115.269 135.938 117.381 133.828 117.381 131.25V18.75C117.381 16.1719 115.269 14.0625 112.686 14.0625H56.3431ZM96.2528 107.812C100.156 107.812 103.296 110.947 103.296 114.844C103.296 118.74 100.156 121.875 96.2528 121.875H72.7765C68.8736 121.875 65.7336 118.74 65.7336 114.844C65.7336 110.947 68.8736 107.812 72.7765 107.812H96.2528ZM14.3205 39.082C17.079 36.8262 21.158 37.002 23.7404 39.5801C26.4989 42.334 26.4989 46.7871 23.7404 49.5117L14.6433 58.5938L22.0971 66.0352L22.9481 66.9727C24.7968 69.2285 25.8239 72.0703 25.8239 75C25.8239 78.3691 24.474 81.5918 22.0971 83.9648L14.6433 91.4062L23.7404 100.488L24.2393 101.016C26.4989 103.77 26.3228 107.842 23.7404 110.42C21.158 112.998 17.079 113.145 14.3205 110.918L13.7923 110.449L3.72686 100.371C1.64334 98.291 0.352145 95.5664 0.058691 92.666L0 91.4062L0.058691 90.1465C0.352145 87.2461 1.64334 84.5215 3.72686 82.4414L11.1806 75L3.72686 67.5586C1.64334 65.4785 0.352145 62.7539 0.058691 59.8535L0 58.5938L0.058691 57.334C0.352145 54.4336 1.64334 51.709 3.72686 49.6289L13.7923 39.5508L14.3205 39.082ZM145.26 39.5508C147.842 36.9727 151.921 36.8262 154.679 39.0527L155.208 39.5508L165.273 49.5996C167.357 51.6797 168.648 54.4043 168.941 57.3047L169 58.5645L168.941 59.8242C168.648 62.7246 167.357 65.4492 165.273 67.5293L157.819 74.9707L165.273 82.4121C167.357 84.4922 168.648 87.2168 168.941 90.1172L169 91.377L168.941 92.6367C168.648 95.5371 167.357 98.2617 165.273 100.342L155.208 110.391L154.679 110.889C151.921 113.145 147.842 112.969 145.26 110.391C142.677 107.812 142.53 103.74 144.761 100.986L145.26 100.459L154.357 91.377L146.903 83.9355C144.526 81.5625 143.176 78.3398 143.176 74.9707C143.176 72.041 144.203 69.1992 146.052 66.9434L146.903 66.0059L154.357 58.5645L145.26 49.4824C142.501 46.7285 142.501 42.2754 145.26 39.5508Z" fill="black"/>
        </svg>
      </div>
      
      <h3 :key="'title-wrapper'" v-html="slide.content.title"></h3>

      <p :key="'byline-wrapper'" v-html="slide.content.byline"></p>

      <button :key="'give-feedback'" @click="takeAction()">Give Nourish feedback</button>

      <!-- <div id="form" class="form-wrap" :key="'form'">
        <div class="res-wrapper" :key="'message-wrapper'" v-if="hasEmailed">
          Message sent! We'll get back to you shortly.
        </div>

        <div class="res-wrapper error" :key="'message-wrapper-error'" v-if="hasError">
          Uh oh. Sorry, that didn't work. Please try again.
        </div>

        <div class="inner-form">
          <form @submit.prevent="send()">
            <textarea placeholder="Message" rows="6" v-model="form.message"></textarea>
            <input type="submit" value="Send message" />
          </form>
        </div>
      </div> -->
    </transition-group>
  </div>
</template>

<script>
  import API from 'app/axios';

  export default {
    data() {
      return {
        reveal: false,
        hasEmailed: false,
        hasError: false,
        form: {
          first_name: '',
          last_name: '',
          email: '',
          message: '',
        }
      }
    },

    props: {
      slide: {
        type: Object,
      },
    },

    mounted () {
      this.$watch('$route.params.stack', (slug) => {
        if (slug === this.slide.slug) {
          this.EventBus.$emit('track:event', {
            event: 'feedback-general',
            props: { mode: 'Opened'},
            detail: { detail_char: 'Opened'},
          });

          this.$emit('swiperUpdate');
          this.$emit('enableNextAction');
          setTimeout(() => {
            this.reveal = true;
          }, 500);
        }
      }, { immediate: true });
    },

    computed: {
      hasApp() {
        return this.$store.getters.hasApp;
      },
    },

    methods: {
      takeAction() {
        this.EventBus.$emit('track:event', {
          event: 'feedback-general',
          props: { mode: 'Tapped Action'},
          detail: { detail_char: 'Tapped Action'},
        });
        
        const userEmail = this.$userEngine.get?.details?.email || '(unknown)';

        const typeForm = `https://form.typeform.com/to/jOdiIslG#email=${userEmail}`;
          
        if (this.hasApp) {
          this.EventBus.$emit("appCallback", {
            type: 'storyCallback',
            data: {
              browser: 'onesub',
              articleURL: typeForm,
            }
          });
        } else {
          window.open(typeForm, 'typeForm');
        }

        this.close();
      },

      close() {
        this.$emit('close');
      },

      send() {
        this.hasError = false;

        API.post(`/account/feedback`, this.form).then(() => {
          this.hasEmailed = true;
        }).catch(() => {
          this.hasError = true;
        });
      },

      next() {
        this.$emit('next');
      }
    },
  }
</script>

<style lang="scss" scoped>
  @import 'src/assets/scss/v5_stacks.scss';

  $emotion-1: rgb(237, 121, 140);
  $emotion-2: rgb(254, 177, 0);
  $emotion-3: rgb(213, 186, 0);
  $emotion-4: rgb(231, 164, 41);
  $emotion-5: rgb(231, 114, 41);

  .card-contact {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    text-align: left;
    max-width: 450px;
    margin: 0 auto;

    .reveal-group {
      z-index: 10;
    }

    .icon {
      margin-bottom: 2rem;

      svg {
        height: 50px;
        width: 50px;

        path {
          fill: $yellow-tone-4;

          .darkmode & {
            fill: $yellow-tone-3;
          }
        }
      }
    }

    h3 {
      font-family: 'Brawler';
      font-size: 50px;
      line-height: 100%;
      font-weight: normal;
      text-wrap: balance;
      margin-bottom: 1.8rem;

      .callout {
        color: $yellow-tone-4;

        .darkmode & {
          color: $yellow-tone-3;
        }
      }

      .desktop & {
        font-size: 70px;
      }
    }

    p {
      font-size: 20px;
      line-height: 150%;
      text-wrap: balance;
    }

    button {
      margin-top: 2rem;
      height: 55px;
      border-radius: 10px;
      font-size: 1rem;
      padding-top: 0.8rem;
    }
  }

  .res-wrapper {
    font-size: 0.9rem;
    font-weight: bold;
    line-height: 140%;
    padding: 0.8rem;
    background: rgba($topics-tone, 0.25);
    color: $topics-tone;
    border-radius: 10px;

    &.error {
      background: rgba($red-tone-3, 0.1);
      color: $red-tone-3;
    }
  }

  .form-wrap {
    display: flex;
    flex-direction: column;
    gap: 1rem;
    margin-top: 2rem;
  }

  form {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: flex-end;
    width: 100%;

    .row {
      display: flex;
      flex-direction: column;
      width: 100%;

      input {
        flex: 1;
        margin-bottom: 1rem;     
        
        &:first-child {
          margin-right: 1rem;
        }
      }

      @media (min-width: $tablet) {
        flex-direction: row;
        margin: 0;
      }
    }

    textarea,
    input {
      font-family: 'Circular';
      font-size: 16px;
      border: 1px solid rgba($neutral-400, 0.25);
      padding: 1rem;
      background: transparent;
      color: $neutral-100;
      border-radius: 5px;
      outline: none;
      box-shadow: unset;
      flex: 1;

      &:focus {
        border: 1px solid $neutral-400;
      }

      .darkmode & {
        color: $neutral-600;
      }
    }

    textarea {
      width: 100%;
      margin-top: 1rem;
    }

    input[type="submit"] {
      padding: 1rem 1.5rem;
      background: $yellow-tone-3;
      font-weight: bold;
      color: $neutral-100;
      outline: none;
      border: none;
      cursor: pointer;
      width: auto;
      margin-left: auto;
      margin-top: 1rem;

      &:focus, &:active {
        outline: none;
        border: none;
      }
    }
  }

  .reveal-group > *:nth-child(2) {
    transition-delay: 0.10s;
  }
  .reveal-group > *:nth-child(3) {
    transition-delay: 0.25s;
  }
  .reveal-group > *:nth-child(4) {
    transition-delay: 0.40s;
  }
</style>

<style lang="scss">
.fade-slide-bottom-enter-active {
  transition: all 0.5s ease;
}
.fade-slide-bottom-enter {
  opacity: 0;
  transform: translateY(50px);
}
.fade-slide-bottom-enter-to {
  opacity: 1;
  transform: translateY(0);
}
</style>